<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <h3 class="text-center">Discount Details<span class="smh"></span></h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-1 p-3">
          <form @submit.prevent="setdiscount">
            <b-form-group
              label="Discount Title"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.discount_title"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Discount Value"
              class="label"
              label-for="target"
            >
              <b-form-spinbutton
                id="numcourses"
                v-model="create.discount_percentage"
                min="1"
                max="100"
              >
              </b-form-spinbutton>
              <b-form-input
                type="range"
                id="numcourses"
                v-model="create.discount_percentage"
                min="1"
                max="100"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Discount Season Status"
              class="label"
              label-for="target"
            >
              <b-form-group>
                <b-form-select v-model="create.discount_season">
                  <b-form-select-option value="true">True</b-form-select-option>
                  <b-form-select-option value="false"
                    >False</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-form-group>

            <b-form-group
              label="Discount Duration (2 weeks, 7 days, etc )"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.discount_duration"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Discount Start"
              class="label"
              label-for="releasedate"
            >
              <b-form-datepicker
                v-model="create.discount_start"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group
              label="Discount End"
              class="label"
              label-for="releasedate"
            >
              <b-form-datepicker
                v-model="create.discount_end"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group
              label="Free Season Status"
              class="label"
              label-for="target"
            >
              <b-form-group>
                <b-form-select v-model="create.free_season">
                  <b-form-select-option value="started">Started</b-form-select-option>
                  <b-form-select-option value="ended"
                    >Ended</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-form-group>

            <b-form-group
              label="Free season start date"
              class="label"
              label-for="releasedate"
            >
              <b-form-datepicker
                v-model="create.free_start"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group
              label="Free season end date"
              class="label"
              label-for="releasedate"
            >
              <b-form-datepicker
                v-model="create.free_end"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group
              label="App current version"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.app_version"
              ></b-form-input>
            </b-form-group>

            <div v-if="sent" class="alert alert-success p-3">
              Platform settings updated Successfully
            </div>

            <div class="text-center">
              <b-overlay
                :show="sending"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class=""
              >
                <div class="mt-4">
                  <b-button
                    :disabled="chkfields"
                    type="submit"
                    variant="outline-success"
                    class="m-lg-3 mt-2 p-2 action-button"
                  >
                    Update Platform settings
                  </b-button>
                </div>
              </b-overlay>

              <b-button
                v-if="sending"
                @click="sending = false"
                class="w-50 p-2 mt-3"
                variant="dark"
              >
                Cancel
              </b-button>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      create: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      opencreate: false,
      isCheckingcode: false,
      couponexists: false,
      uploadingfile: false,
      uploadedfile: false,
      uploadmessage: "",
      mtype: "",
      filedir: "",
      filelink: "",
      uploadingcimage: false,
      status: ""
      // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchDiscountDetails");
    next();
  },
  mounted() {
    store.dispatch("admin/fetchDiscountDetails");

    this.create.discount_duration = this.discountdetails.discount_duration;
    this.create.discount_coverage = this.discountdetails.discount_coverage;
    this.create.discount_start = this.discountdetails.discount_start;
    this.create.discount_end = this.discountdetails.discount_end;
    this.create.discount_title = this.discountdetails.discount_title;
    this.create.discount_season = this.discountdetails.discount_season;
    this.create.discount_percentage = this.discountdetails.discount_percentage;
    this.create.free_start = this.discountdetails.free_start;
    this.create.free_end = this.discountdetails.free_end;
    this.create.free_season = this.discountdetails.free_season;
    this.create.app_version = this.discountdetails.app_version;
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      couponsarray: state => state.admin.coupons,
      adminadded: state => state.admin.adminadded,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin,
      discountdetails: state => state.admin.discountdetails
    }),

    chkfields() {
      if (this.sending) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("admin", ["setDiscount", "fetchDiscountDetails"]),
    getForm() {
      return {
        discount_coverage: "all",
        discount_season: "",
        discount_title: "",
        discount_percentage: 0,
        discount_start: "",
        discount_end: "",
        discount_duration: "",
        free_season: "",
        app_version: 0,
        free_start: "",
        free_end: "",
        admintrackid: ""
      };
    },
    setdiscount() {
      this.sending = true;
      // this.user.organization = this.details.clearance_organization
      this.create.adminname = this.details.fullname;
      this.create.admintrackid = this.details.trackid;
      // this.create.discount_season = Boolean(this.create.discount_season)

      return this.setDiscount(this.create).then(() => {
        this.sending = false;
        this.sent = true;

        this.fetchDiscountDetails();
      });
    },
    stopproceed() {
      this.sending = false;
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 11%;
  padding: 2px;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 95%;
}
.right-flex-child {
  width: 5%;
}
.hidden {
  display: none;
}
.full-width-child {
  width: 100%;
}
.font-green {
  color: green;
}
.errtxt {
  color: red;
}
.dispimage {
  width: 70%;
  height: 400px;
  border: 3px solid white;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
  .dispimage {
    width: 100%;
  }
}
</style>
